var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.bannerAlt !== false)?_c('banner-section',{attrs:{"banner":_vm.bannerAlt}}):_vm._e(),_c('gallery-section',{attrs:{"gallery":_vm.images}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }